export default __webpack_public_path__ + "static/IBMPlexSans-Regular-Cyrillic-022d7839fbf0b01f127936aa3f3c94e5.woff2";